function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var Lifecycle =
/*#__PURE__*/
function () {
  function Lifecycle() {
    _classCallCheck(this, Lifecycle);

    this.events = {}; // Guard in case setTimeout(fn, 0) order is indeterminate

    this.triggerQueue = [];
  }

  _createClass(Lifecycle, [{
    key: "getEventObj",
    value: function getEventObj(eventName) {
      if (!this.events[eventName]) {
        this.events[eventName] = {
          instances: []
        };
      }

      return this.events[eventName];
    }
  }, {
    key: "on",
    value: function on(eventName, options, fn) {
      if (typeof options === 'function') {
        fn = options;
        options = {};
      }

      var event = this.getEventObj(eventName);
      var instance = {
        fn: fn,
        options: options
      };

      if (options.immediate && event.triggerArgs) {
        fn.apply(void 0, _toConsumableArray(event.triggerArgs));
        instance.triggered = true;
      }

      event.instances.push(instance);
      return this;
    }
  }, {
    key: "triggerSync",
    value: function triggerSync(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var event = this.getEventObj(eventName);
      event.triggerArgs = args;
      event.instances.forEach(function (instance) {
        var once = instance.options.once,
            triggered = instance.triggered;

        if (!once || !triggered) {
          try {
            instance.fn.apply(instance, args);
          } catch (err) {// discard any exceptions
          }

          if (once) {
            instance.triggered = true;
          }
        }
      });
      return this;
    }
  }, {
    key: "trigger",
    value: function trigger(eventName) {
      var _this = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this.triggerQueue.push({
        eventName: eventName,
        args: args
      });
      setTimeout(function () {
        var _this$triggerQueue$sh = _this.triggerQueue.shift(),
            eventName = _this$triggerQueue$sh.eventName,
            args = _this$triggerQueue$sh.args;

        _this.triggerSync.apply(_this, [eventName].concat(_toConsumableArray(args)));
      }, 0);
      return this;
    }
  }, {
    key: "script",
    value: function script(src, onload) {
      var props;

      if (typeof src === 'string') {
        props = {
          src: src
        };

        if (onload) {
          props.onload = onload;
        }
      } else {
        props = src;
      }

      var script = document.createElement('script');
      Object.keys(props).forEach(function (prop) {
        script[prop] = props[prop];
      });
      document.head.appendChild(script);
      return this;
    }
  }]);

  return Lifecycle;
}();

export default Lifecycle;
